import { SousMenuItemAggregate } from '../../../../../aggregats/menu/sous-menu-item.aggregate';
import { AutorisationsAggregate } from '../../../../../aggregats/autorisation/autorisations.aggregate';
import { AutorisationAggregate } from '../../../../../aggregats/autorisation/autorisation.aggregate';
import { FonctionLogicielle } from '../../../../fonctions-logicielle-constantes';
import { EparcoursPath } from '../../eparcours-path';
import { StatistiquesPath } from 'src/app/pages/statistiques/statistiques-path';

export const exportBpfSousMenuItem = new SousMenuItemAggregate(
    'Export BPF',
    `/${EparcoursPath.root.STATISTIQUES}/${StatistiquesPath.BPF}`,
    new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.ExportBPF)]),
);

export const financierSousMenuItem = new SousMenuItemAggregate(
    'Financier',
    `/${EparcoursPath.root.STATISTIQUES}/${StatistiquesPath.FINANCIER}`,
    new AutorisationsAggregate([
      new AutorisationAggregate(FonctionLogicielle.TdbFinancier),
      new AutorisationAggregate(FonctionLogicielle.TdbFinancierModifiable)]),
);

export const participantSousMenuItem = new SousMenuItemAggregate(
    'Participant',
    `/${EparcoursPath.root.STATISTIQUES}/${StatistiquesPath.PARTICIPANT}`,
    new AutorisationsAggregate([
      new AutorisationAggregate(FonctionLogicielle.TdbParticipant),
      new AutorisationAggregate(FonctionLogicielle.TdbParticipantModifiable)]),
);

export const formateurSousMenuItem = new SousMenuItemAggregate(
    `Formateur`,
    `/${EparcoursPath.root.STATISTIQUES}/${StatistiquesPath.FORMATEUR}`,
    new AutorisationsAggregate([
      new AutorisationAggregate(FonctionLogicielle.TdbFormateur),
      new AutorisationAggregate(FonctionLogicielle.TdbFormateurModifiable)]),
);

export const qualitySousMenuItem = new SousMenuItemAggregate(
    `Qualité`,
    `/${EparcoursPath.root.STATISTIQUES}/${StatistiquesPath.QUALITY}`,
    new AutorisationsAggregate([
      new AutorisationAggregate(FonctionLogicielle.TdbQualite),
      new AutorisationAggregate(FonctionLogicielle.TdbQualiteModifiable)]),
);

export const sessionSousMenuItem = new SousMenuItemAggregate(
    `Session`,
    `/${EparcoursPath.root.STATISTIQUES}/${StatistiquesPath.SESSION}`,
    new AutorisationsAggregate([
      new AutorisationAggregate(FonctionLogicielle.TdbSession),
      new AutorisationAggregate(FonctionLogicielle.TdbSessionModifiable)]),
);

export const commercialSousMenuItem = new SousMenuItemAggregate(
    `Commercial`,
    `/${EparcoursPath.root.STATISTIQUES}/${StatistiquesPath.COMMERCIAL}`,
    new AutorisationsAggregate([
      new AutorisationAggregate(FonctionLogicielle.TdbCommercial),
      new AutorisationAggregate(FonctionLogicielle.TdbCommercialModifiable)]),
);
